import axios from 'axios';
import * as actionTypes from './types';

export const addQuipAccessToken = (quipAccessToken) => ({
  type: actionTypes.ADD_QUIP_ACCESS_TOKEN,
  quipAccessToken: quipAccessToken,
});

export const createQuip = (quipToken, journeyId) => async (dispatch) => {
  dispatch(setQuipLoading(true));
  try {
    const res = await axios.post('/api/quip', {
      quipToken,
      journeyId,
    });
    if (res.data.thread) {
      if (res.data.thread.link) {
        dispatch(addQuipLink(res.data.thread.link));
        dispatch(updateQuipThreadId(res.data.thread.id));
      }
    }
    // set loading to false regardless
    dispatch(setQuipError(''));

    if (res.data.error) {
      if (res.data.error && res.data.error_description) {
        dispatch(
          setQuipError(`${res.data.error}: ${res.data.error_description}`)
        );
      } else {
        dispatch(setQuipError('Unknown Error'));
      }
    }

    dispatch(setQuipLoading(false));
  } catch (err) {
    if (typeof err === 'object' && err !== null) {
      if (err.error && err.error_description) {
        dispatch(setQuipError(`${err.error}: ${err.error_description}`));
      } else {
        dispatch(setQuipError(JSON.stringify(err)));
      }
    }
    dispatch(setQuipError('Unknown Error'));
    dispatch(setQuipLoading(false));
    console.error(err);
  }
};

export const setQuipLoading = (isLoading) => ({
  type: actionTypes.SET_QUIP_LOADING,
  isLoading,
});

export const addQuipLink = (quipLink) => ({
  type: actionTypes.ADD_QUIP_LINK,
  quipLink,
});

export const updateQuipThreadId = (quipThreadId) => ({
  type: actionTypes.UPDATE_QUIP_THREAD_ID,
  quipThreadId,
});

export const setQuipError = (errorMessage) => ({
  type: actionTypes.SET_QUIP_ERROR,
  errorMessage,
});
